// extracted by mini-css-extract-plugin
module.exports = {"result-stats":"BaseResultStats_result-stats__Z0Wa9","search-fade-in":"BaseResultStats_search-fade-in__Uszwf"};